import { useState } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import Select from './Select'
import ButtonUpload from './ButtonUpload'
import { getStagioni } from '../hooks/selection-get-functions'
import { useGetCampionatiQuery } from '../hooks/api-slice'

const DialogUploadTesserati = ({ open, handleClose }) => {
  const { data: campionati } = useGetCampionatiQuery()

  const stagioni = getStagioni(campionati?.filter(c => !c.campionatoChiuso))

  const [uploadStagione, setUploadStagione] = useState()

  return (
    <Dialog open={open} handleClose={handleClose} title='Carica tesserati'>
      <Grid container spacing={3} paddingTop={1} sx={{ width: '100%' }}>
        <Grid size={12}>
          <Select
            id='stagione'
            label='Stagione'
            value={uploadStagione}
            options={stagioni}
            onChange={setUploadStagione}
          />
        </Grid>
        <Grid size={12}>
          I dati dei tesserati già presenti in piattaforma verranno aggiornati
          con i dati presenti nel file.
          <br />
          <br />
          <b>
            Alla fine, leggere il LOG per verificare il corretto caricamento di
            tutti i tesserati.
          </b>
          <br />
        </Grid>
        <Grid size={12}>
          <center>
            <ButtonUpload
              buttonText='Carica CSV'
              algorithm='19_UpdateTesserati'
              runScript
              uploadStagione={uploadStagione}
            />
          </center>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogUploadTesserati
